import { useCallback, useRef, useState } from 'react';
import Map from 'ol/Map';
import { View } from 'ol';
import { createOsmBaseLayer } from 'utils/map/baseLayers';

const DEFAULT_CENTER = [1.416517405965338e7, 4294546.35698363];
const DEFAULT_ZOOM = 6;

const createDefaultBaseLayer = () =>
    createOsmBaseLayer({
        title: 'OpenStreetMap',
    });

const useBaseOlMap = ({
    targetId = 'map_area',
    initialCenter = DEFAULT_CENTER,
    initialZoom = DEFAULT_ZOOM,
    minZoom = 7,
    maxZoom = 16,
    baseLayerFactory,
} = {}) => {
    const mapRef = useRef(null);

    const [mapCenter, setMapCenter] = useState(initialCenter);
    const [mapZoomLevel, setMapZoomLevel] = useState(initialZoom);
    const [isMapReady, setIsMapReady] = useState(false);

    const initializeMap = useCallback(() => {
        if (mapRef.current) {
            return mapRef.current;
        }

        const baseLayer = typeof baseLayerFactory === 'function' ? baseLayerFactory() : createDefaultBaseLayer();

        const view = new View({
            center: initialCenter,
            zoom: initialZoom,
            maxZoom,
            minZoom,
        });

        const map = new Map({
            layers: [baseLayer],
            target: targetId,
            view,
        });

        map.on('moveend', () => {
            setMapCenter(map.getView().getCenter());
            setMapZoomLevel(map.getView().getZoom());
        });

        mapRef.current = map;
        setIsMapReady(true);
        return map;
    }, [baseLayerFactory, initialCenter, initialZoom, maxZoom, minZoom, targetId]);

    return {
        mapRef,
        mapCenter,
        mapZoomLevel,
        isMapReady,
        initializeMap,
    };
};

export default useBaseOlMap;
